// extracted by mini-css-extract-plugin
export default {"list":"QuickActions_list__2CUaP","item":"QuickActions_item__2C_Q1","loading":"QuickActions_loading__Xltyl","icon":"QuickActions_icon__3gXft"};